import { ImageWithFallback } from '@wbk/ui';
import { useTranslation } from '@wbk/config';
import useLocalization from '@/context/localization/useLocalization';
import ActionButton from '../buttons/ActionButton';
import PageBanner from '../ui/Banner/PageBanner';

const New404 = () => {
  const { t } = useTranslation('common');
  const { locale } = useLocalization();
  return (
    <div className='relative min-h-screen overflow-hidden bg-black text-white'>
      <PageBanner
        backgroundImage='/images/error_bg.png'
        backgroundVideo='/images/faq/faq_bg_video.mp4'
        videoOpacity={40}
        className='!h-full'
        alt='404 page background'
      />

      <div className='relative mx-auto flex max-w-7xl flex-col items-center space-y-6 px-4 pt-60 text-center sm:px-6 md:block md:text-left lg:px-8'>
        <ImageWithFallback className='max-w-[280px] md:max-w-full' src='/images/404.svg' />
        <h1 className='!mt-14 text-start text-2xl md:text-3xl lg:text-5xl'>{t('errors.404')}</h1>
        <p className='!mb-16 max-w-sm px-4 text-center text-gray-300 sm:px-0 sm:text-start sm:text-xl md:max-w-lg lg:max-w-xl'>
          {t('errors.404_description')}
        </p>
        <ActionButton
          iconSrc={`/icons/Arrow-${locale === 'ar' ? 'right' : 'left'}.svg`}
          iconPosition='left'
          as='a'
          className='w-fit'
          href='/'
        >
          {t('errors.back_to_home')}
        </ActionButton>
      </div>
    </div>
  );
};

export default New404;
